import { useTranslation } from "react-i18next";

const STEPS = [
  "google_help.step1",
  "google_help.step2",
  "google_help.step3",
  "google_help.step4",
  "google_help.step5",
] as const;

/** How a vendor finds their Google review link. */
const GoogleReviewsLinkHelp: React.FC = () => {
  const { t } = useTranslation("profile");

  return (
    <div>
      <strong>{t("google_help.title")}</strong>
      <ol style={{ margin: "4px 0 0", paddingLeft: 18 }}>
        {STEPS.map((step) => (
          <li key={step}>{t(step)}</li>
        ))}
      </ol>
    </div>
  );
};

export default GoogleReviewsLinkHelp;
